var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.94,
    height: 60.94,
    viewBox: "0 0 60.94 60.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_868",
    "data-name": "Grupo 868",
    transform: "translate(3798.9 1406.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_861",
    "data-name": "Grupo 861",
    transform: "translate(-3798.9 -1406.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2375",
    "data-name": "Caminho 2375",
    d: "M-3431.9-690.728a30.327,30.327,0,0,1-15.633,4.31,30.327,30.327,0,0,1-15.632-4.31,29.643,29.643,0,0,0,15.632-26.132A29.644,29.644,0,0,0-3431.9-690.728Z",
    transform: "translate(3477.998 747.357)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2376",
    "data-name": "Caminho 2376",
    d: "M-3432.862-1402.6a29.645,29.645,0,0,0-15.679,26.158,29.644,29.644,0,0,0-15.679-26.158,30.325,30.325,0,0,1,15.679-4.339A30.324,30.324,0,0,1-3432.862-1402.6Z",
    transform: "translate(3479.011 1406.94)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_860",
    "data-name": "Grupo 860",
    transform: "translate(0 4.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2377",
    "data-name": "Caminho 2377",
    d: "M-3078.96-1282.639a30.453,30.453,0,0,1-14.838,26.159,29.643,29.643,0,0,1-15.632-26.132,29.644,29.644,0,0,1,15.679-26.158A30.455,30.455,0,0,1-3078.96-1282.639Z",
    transform: "translate(3139.9 1308.77)",
    fill: "#f79e1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2378",
    "data-name": "Caminho 2378",
    d: "M-3768.43-1282.6a29.643,29.643,0,0,1-15.633,26.132,30.453,30.453,0,0,1-14.837-26.159,30.452,30.452,0,0,1,14.79-26.131A29.644,29.644,0,0,1-3768.43-1282.6Z",
    transform: "translate(3798.899 1308.76)",
    fill: "#eb001b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_862",
    "data-name": "Grupo 862",
    transform: "translate(-3783.974 -1386.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_98",
    "data-name": "Elipse 98",
    cx: 9.59,
    cy: 9.59,
    r: 9.59,
    transform: "translate(11.909 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_99",
    "data-name": "Elipse 99",
    cx: 9.59,
    cy: 9.59,
    r: 9.59,
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.ccf8197d5267f19c9184b3d760d04075.svg";
export { ForwardRef as ReactComponent };